<div class="card-flight is-size-7" [class.clean]="cleanColor">
  <div class="columns mb-0">
    <div class="column is-6">
      <span class="weight-medium">
        {{ 'itinerary-info.flight.departure' | translate }}
      </span>
      <span class="is-capitalized">
        {{
          flight?.departureDate || flight?.departureDateTime
            | date
            | localizedDate : 'EEE d MMM y'
        }}
        •
      </span>
      {{ flight?.departureDate || flight?.departureDateTime | date : 'HH:mm' }}
    </div>
    <div class="column">
      <span class="">
        {{ 'itinerary-info.flight.class' | translate }} {{ flight?.classOfService }}
      </span>
    </div>
    <div class="column is-narrow">
      <span class="is-pulled-right pr-2">
        {{ 'itinerary-info.flight.flight' | translate }}
        {{ flight?.number || flight?.flightNumber }}
      </span>
    </div>
  </div>
  <div class="columns mb-0">
    <div class="column is-offset-1">
      <span class="is-block weight-medium">
        {{ flight?.departureLocation?.name || flight?.departure?.name }}
      </span>
      <span class="weight-medium"
        >({{ flight?.departureLocation?.code || flight?.departure?.code }})
      </span>
      <span class="is-capitalized">
        {{ flight?.departureLocation?.airportName || flight?.departure?.airportName | lowercase }}
      </span>
    </div>
  </div>

  <div class="columns mb-0">
    <div class="column">
      <span class="weight-medium">
        {{ 'itinerary-info.flight.arrival' | translate }}
      </span>
      <span class="is-capitalized">
        {{ flight?.arrivalDate || flight?.arrivalDateTime | date | localizedDate : 'EEE d MMM y' }} •
      </span>
      {{ flight?.arrivalDate || flight?.arrivalDateTime | date : 'HH:mm' }}
    </div>
  </div>
  <div class="columns mb-0">
    <div class="column is-offset-1">
      <span class="is-block weight-medium">
        {{ flight?.arrivalLocation?.name || flight?.arrival?.name }}
      </span>
      <span class="weight-medium">
        ({{ flight?.arrivalLocation?.code || flight?.arrival?.code }})
      </span>
      <span class="is-capitalized">
        {{ flight?.arrivalLocation?.airportName || flight?.arrival?.airportName | lowercase }}
      </span>
    </div>
  </div>
</div>
